exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".md-theme-default.md-tabs>.md-tabs-navigation{background-color:#fff}.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header,.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active,.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus{color:#6e6b79}.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-indicator{background-color:#002b48;height:4px;border-radius:10px}.md-whiteframe{background:#fff;box-shadow:0 4px 24px 0 rgb(34 41 47/10%);-webkit-box-shadow:0 4px 24px 0 rgb(34 41 47/10%);border-radius:.423rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-16a17be6","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/reports/freightReports.vue
// module id = 1405
// module chunks = 0